import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../../api/apiService";
import { toast } from "react-toastify";

const Settings = () => {

  const [generalSettings, setGeneralSettings] = useState({
    id: null,
    auto_reply: false,
    auto_reply_message: "",
    auto_approve_attendance: false,
    lateness_threshold: null,
    company: "",
    auto_checkout_hours: null,
    week_days: {
      saturday: false,
      sunday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
    },
  });

  useEffect(() => {
    fetchGeneralSettings();
  }, []);


  const fetchGeneralSettings = async () => {
    try {
      const response = await api.get("/admin/settings/general");
      const config = response.data.config;

      setGeneralSettings({
        id: response.data.id,
        auto_reply: config.auto_reply,
        auto_reply_message: config.auto_reply_message,
        auto_approve_attendance: config.auto_approve_attendance,
        lateness_threshold: config.lateness_threshold,
        company: config.company,
        auto_checkout_hours: config.auto_checkout_hours,
        week_days: config.week_days || {
          saturday: false,
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
        },
      });
    } catch (error) {
      console.error("Error fetching General settings:", error);
    }
  };

  const updateGeneralSettings = async () => {
    try {
      const data = {
        type: "general",
        config: {
          auto_reply: generalSettings.auto_reply,
          auto_approve_attendance: generalSettings.auto_approve_attendance,
          auto_reply_message: generalSettings.auto_reply_message,
          week_days: generalSettings.week_days,
          lateness_threshold: generalSettings.lateness_threshold,
          company: generalSettings.company,
          auto_checkout_hours: generalSettings.auto_checkout_hours
        },
      };
      await api.post(`/admin/settings/${generalSettings.id}`, data);
      toast.success("Settings updated successfully");
      localStorage.setItem("company", generalSettings.company);
      fetchGeneralSettings();
    } catch (error) {
      if (error.data && error.data.errors) {
        error.data.errors.forEach(err => {
          toast.error(err);
        });
      } else {
        toast.error("Fail to update General settings");
      }
    }
  };

  const weekdays = [
    "saturday",
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
  ];


  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>Settings</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/user/meetings">Home</Link>
            </li>
            <li className="breadcrumb-item">Users</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Settings</h5>

                {/* Twilio Settings */}

                <div className="row">
                  <div className="col-md-6">
                    {/* General Settings */}
                    <div className="settings-section">
                      <h2>General Settings</h2>

                      <div className="row">
                        <div className="col-md-7 col-12">
                          <div className="form-group">
                            <label>
                              <input
                                type="checkbox"
                                checked={generalSettings.auto_approve_attendance}
                                className="me-1"
                                onChange={(e) =>
                                  setGeneralSettings({
                                    ...generalSettings,
                                    auto_approve_attendance: e.target.checked,
                                  })
                                }
                              />
                              Auto Approve Attendance
                            </label>
                          </div>
                        </div>

                        <div className="col-md-7 col-12">
                          <div className="form-group">
                            <label>Lateness Threshold (minutes):</label>
                            <input
                              type="number"
                              className="form-control"
                              value={generalSettings.lateness_threshold}
                              onChange={(e) =>
                                setGeneralSettings({
                                  ...generalSettings,
                                  lateness_threshold: parseInt(e.target.value, 10),
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-7 col-12">
                          <div className="form-group">
                            <label>Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={generalSettings.company}
                              onChange={(e) =>
                                setGeneralSettings({
                                  ...generalSettings,
                                  company: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-7 col-12">
                          <div className="form-group">
                            <label>Auto Checkout Hours</label>
                            <input
                              type="number"
                              className="form-control"
                              value={generalSettings.auto_checkout_hours}
                              onChange={(e) =>
                                setGeneralSettings({
                                  ...generalSettings,
                                  auto_checkout_hours: parseInt(e.target.value, 10),
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <h3>Weekly Holidays:</h3>
                      <div className="row">
                        {weekdays.map((day) => (
                          <div className="col-md-4 col-12" key={day}>
                            <div className="form-group">
                              <label>
                                <input
                                  type="checkbox"
                                  checked={generalSettings.week_days[day]}
                                  onChange={(e) =>
                                    setGeneralSettings({
                                      ...generalSettings,
                                      week_days: {
                                        ...generalSettings.week_days,
                                        [day]: e.target.checked,
                                      },
                                    })
                                  }
                                />
                                {day.charAt(0).toUpperCase() + day.slice(1)}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>

                      <button
                        className="btn btn-primary"
                        onClick={updateGeneralSettings}
                      >
                        Update General Settings
                      </button>
                    </div>
                  </div>
                </div>

                <br />

              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Settings;
